import * as yup from 'yup'
import { addFleetContactStructure } from '../../../../validation/fleet'

export const contactFormValidation = yup
  .object()
  .shape(addFleetContactStructure)
